import { render, staticRenderFns } from "./LUCEE.vue?vue&type=template&id=23ab1dfc"
import script from "./LUCEE.vue?vue&type=script&lang=js"
export * from "./LUCEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports